<template>
  <div class="wrapper">
    <h3 class="title">{{ $t('ApplicationList_NoData_Title') }}</h3>
    <p class="description">
      {{ $t('ApplicationList_NoData_Description') }}
    </p>
    <slot name="actions" />
  </div>
</template>

<script>
export default {
  name: 'ApplicationListNoData'
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 140px 70px;
  background: #ffffff;
  border: 1px solid #ebeef5;
  box-shadow: 0 4px 8px rgba(75, 81, 95, 0.05);
  border-radius: 4px;
}
.title {
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  text-align: center;
  color: #5c6374;
  margin-bottom: 8px;
}
.description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: #7e8596;
}
.btn-connect {
  background-color: transparent;
  border-color: #1d87c8;
  color: #1d87c8;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
  margin: 24px auto 0;
}
.btn-connect span {
  color: #1d87c8;
}
</style>



// WEBPACK FOOTER //
// src/modules/account/components/ApplicationListNoData.vue